import type {AtsEntityAction} from 'src/action-creators/ats-entities';
import type {
  AtsClientEntity,
  EntityAttributeSchema,
  Usage,
  EntityMetadataObject,
} from 'src/types/ats-entities';

import {
  RECEIVE_ENTITIES,
  RECEIVE_ATTRIBUTES,
  RECEIVE_ENTITIES_USAGE,
  RECEIVE_METADATA,
} from 'src/action-creators/ats-entities';


export type State = {
  entities: AtsClientEntity[];
  // TODO (kyle): this is a legacy prop that we should remove
  // when we can confirm it's never referenced.
  attributes: Record<any, any>;
  simpleAttributes: Map<string, EntityAttributeSchema>;
  allAttributes: Map<string, EntityAttributeSchema>;
  usages: Usage[];
  entityMetadata: {
    [key: string]: EntityMetadataObject;
  };
};

const initialState = {
  entities: [],
  // @ts-expect-error - TS2698 - Spread types may only be created from object types.
  attributes: {...null},
  simpleAttributes: new Map(),
  allAttributes: new Map(),
  usages: [],
  entityMetadata: {},
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly entities: readonly []; readonly attributes: any; readonly simpleAttributes: Map<any, any>; readonly allAttributes: Map<any, any>; readonly usages: readonly []; readonly entityMetadata: {}; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: AtsEntityAction,
): State => {
  switch (action.type) {
    case RECEIVE_ENTITIES: {
      // @ts-expect-error - TS2322 - Type '{ entities: AtsEntities; attributes?: Record<any, any> | undefined; simpleAttributes?: Map<string, EntityAttributeSchema> | undefined; allAttributes?: Map<...> | undefined; usages?: Usage[] | undefined; entityMetadata?: { ...; } | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        entities: action.payload,
      };
    }

    case RECEIVE_ENTITIES_USAGE: {
      // @ts-expect-error - TS2322 - Type '{ usages: Usage[]; entities?: AtsEntity[] | undefined; attributes?: Record<any, any> | undefined; simpleAttributes?: Map<string, EntityAttributeSchema> | undefined; allAttributes?: Map<...> | undefined; entityMetadata?: { ...; } | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        usages: action.payload,
      };
    }

    case RECEIVE_ATTRIBUTES: {
      // @ts-expect-error - TS2322 - Type '{ simpleAttributes: Map<any, any>; allAttributes: Map<any, any>; entities?: AtsEntity[] | undefined; attributes?: Record<any, any> | undefined; usages?: Usage[] | undefined; entityMetadata?: { ...; } | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        simpleAttributes: action.payload.reduce(
          (map, attr) => (attr.hidden ? map : map.set(attr.id, attr)),
          new Map(),
        ),
        allAttributes: action.payload.reduce(
          (map, attr) => map.set(attr.id, attr),
          new Map(),
        ),
      };
    }
    case RECEIVE_METADATA: {
      // @ts-expect-error - TS2322 - Type '{ entityMetadata: { [key: string]: EntityMetadataObject; }; entities?: AtsEntity[] | undefined; attributes?: Record<any, any> | undefined; simpleAttributes?: Map<...> | undefined; allAttributes?: Map<...> | undefined; usages?: Usage[] | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        entityMetadata: action.payload,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
